import { useCallback, useMemo } from 'react';
import { useUpdateHarmonyTheme } from './useUpdateHarmonyTheme';
export var useUserSettingsCallbacks = function () {
    var updateTheme = useUpdateHarmonyTheme();
    /**
     * Callback for theme mode change
     */
    var onThemeModeChange = useCallback(function (mode) {
        updateTheme({
            mode: mode,
        }, 'HarmonyThemeModeChange');
    }, [updateTheme]);
    /**
     * Callback for theme id change
     * Currently would not be called from anywhere
     */
    var onThemeIdChange = useCallback(function (id) {
        updateTheme({
            id: id,
        }, 'HarmonyThemeIdChange');
    }, [updateTheme]);
    /**
     * Callback for preferHarmonyTheme change
     * Currently would not be called from anywhere
     */
    var onPreferHarmonyThemeChange = useCallback(function (preferHarmonyTheme) {
        updateTheme({
            preferHarmonyTheme: preferHarmonyTheme,
        }, 'HarmonyThemePreferChange');
    }, [updateTheme]);
    return useMemo(function () {
        if (!onPreferHarmonyThemeChange ||
            !onThemeIdChange ||
            !onThemeModeChange) {
            return undefined;
        }
        return {
            onPreferHarmonyThemeChange: onPreferHarmonyThemeChange,
            onThemeIdChange: onThemeIdChange,
            onThemeModeChange: onThemeModeChange,
        };
    }, [onPreferHarmonyThemeChange, onThemeIdChange, onThemeModeChange]);
};
//# sourceMappingURL=useUserSettingsCallbacks.js.map